interface ReassignmentPreviewProps {
  summary: Record<string, number>
  targetUser: string
  loading: boolean
  error?: string
}

export function ReassignmentPreview({
  summary,
  targetUser,
  loading,
  error,
}: ReassignmentPreviewProps) {
  if (loading) {
    return <p className="text-sm text-muted-foreground">Loading preview...</p>
  }

  if (error) {
    return <p className="text-sm text-destructive">{error}</p>
  }

  const entries = Object.entries(summary)

  if (entries.length === 0) {
    return <p className="text-sm text-muted-foreground">No records to reassign.</p>
  }

  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">
        Records will be reassigned to <strong>{targetUser}</strong>:
      </p>
      <ul className="list-inside list-disc space-y-1 text-sm">
        {entries.map(([model, count]) => {
          const shortName = model.split('::').pop()?.toLowerCase() ?? model
          return (
            <li key={model}>
              {count} {shortName}{count !== 1 ? 's' : ''}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
